import { useOutletContext } from 'react-router-dom'
import type { SiteContext } from '../components/MainLayout'
import { StaggerGroup } from '../components/motion'
import PricingSection from '../components/PricingSection'
import { CallToAction, FaqSection, PageIntro, SectionHeading } from '../components/ui'
import { routeFor } from '../config/routes'
import { siteConfig, type PricingCategory } from '../config/site'
import { usePageMeta } from '../hooks/usePageMeta'

export default function ServicesPageV2() {
  const { language, copy } = useOutletContext<SiteContext>()
  const page = copy.services
  const serviceCategories = siteConfig.pricing.categories as readonly PricingCategory[]
  usePageMeta({ language, title: page.eyebrow, description: page.intro })
  return (
    <>
      <PageIntro eyebrow={page.eyebrow} title={page.title} text={page.intro} />
      <section className="section service-list-section"><StaggerGroup className="shell service-list">
        {serviceCategories.map((service, index) => (
          <article className="service-row" id={service.anchor} key={service.id}>
            <span className="service-row__number">{String(index + 1).padStart(2, '0')}</span>
            <div className="service-row__title"><h2>{service.title[language]}</h2><p>{service.description[language]}</p></div>
            <ul>{service.bullets.map((bullet) => <li key={bullet[language]}>{bullet[language]}</li>)}</ul>
          </article>
        ))}
      </StaggerGroup></section>
      <section className="section process-section"><div className="shell"><SectionHeading eyebrow={page.processEyebrow} title={page.processTitle} /><StaggerGroup className="process-list">{page.process.map((step) => <article className="process-step" key={step.number}><span>{step.number}</span><h3>{step.title}</h3><p>{step.text}</p></article>)}</StaggerGroup></div></section>
      <PricingSection language={language} />
      <FaqSection eyebrow={page.faqEyebrow} title={page.faqTitle} items={page.faq} language={language} />
      <CallToAction eyebrow="FOTIS MYTIKAS / DIGITAL SERVICES" title={page.ctaTitle} text={page.ctaText} button={copy.common.requestQuote} to={routeFor(language, 'contact')} />
    </>
  )
}
